import { render } from "./WebRTCPlayer.vue?vue&type=template&id=624e37c0&scoped=true"
import script from "./WebRTCPlayer.vue?vue&type=script&lang=js"
export * from "./WebRTCPlayer.vue?vue&type=script&lang=js"

import "./WebRTCPlayer.vue?vue&type=style&index=0&id=624e37c0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624e37c0"]])

export default __exports__